// src/store/wsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isWSMessage, type WSMessage } from "../websocket/wsTypes";

export type WsStatus = "idle" | "connecting" | "open" | "closed" | "error" | "created"| "connected";

export interface WsLoggedMessage {
    id: string;                 // auto id để log
    direction: "incoming" | "outgoing";
    raw: WSMessage;             // message đúng format backend
}

export interface WsState {
    status: WsStatus;
    lastError?: string | null;
    lastConnectedAt?: number;
    lastDisconnectedAt?: number;
    messages: WsLoggedMessage[];
    maxMessages: number;
}

const initialState: WsState = {
    status: "connecting",
    messages: [],
    maxMessages: 2000,
};

const wsSlice = createSlice({
    name: "ws",
    initialState,
    reducers: {
        wsCreated(state) {
            state.status = "created";
            state.lastError = undefined;
            console.log("🟡 WS instance created");
        },
        wsConnecting(state) {
            state.status = "connecting";
            state.lastError = undefined;
        },
        wsOpen(state) {
            state.status = "connected";
            state.lastConnectedAt = Date.now();
            state.lastError = undefined;
        },
        wsClosed(state) {
            state.status = "closed";
            state.lastDisconnectedAt = Date.now();
        },
        wsError(state, action: PayloadAction<string>) {
            state.status = "error";
            state.lastError = action.payload;
        },

        wsIncoming(state, action: PayloadAction<WSMessage>) {
            const id = `${Date.now()}-${state.messages.length}`;
            state.messages.push({
                id,
                direction: "incoming",
                raw: action.payload,
            });
            if (state.messages.length > state.maxMessages) {
                state.messages.splice(
                    0,
                    state.messages.length - state.maxMessages
                );
            }

            if (isWSMessage(action.payload)) {
                console.log("    ✔ Valid WSMessage", action.payload);
            } else {
                //console.log("✅ WS Incoming ", action.type,);
            }
        },

        wsOutgoing(state, action: PayloadAction<WSMessage>) {
            const id = `${Date.now()}-${state.messages.length}`;
            state.messages.push({
                id,
                direction: "outgoing",
                raw: action.payload,
            });
            if (state.messages.length > state.maxMessages) {
                state.messages.splice(
                    0,
                    state.messages.length - state.maxMessages
                );
            }
        },

        wsClearMessages(state) {
            state.messages = [];
        },

        wsSetMaxMessages(state, action: PayloadAction<number>) {
            state.maxMessages = action.payload;
            if (state.messages.length > state.maxMessages) {
                state.messages.splice(
                    0,
                    state.messages.length - state.maxMessages
                );
            }
        },
    },
});

export const {
    wsConnecting,
    wsOpen,
    wsClosed,
    wsError,
    wsIncoming,
    wsOutgoing,
    wsClearMessages,
    wsSetMaxMessages,
} = wsSlice.actions;

export default wsSlice.reducer;